module.exports = __webpack_public_path__ + "img/0x3Bf0880fd26E49c46d1A1e69ADb268889B4be840.bc2e304f.png";